import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Edit } from "lucide-react";

export const Route = createFileRoute("/_app/rh/planning/$id/edit")({
  loader: requirePermission(PERMISSIONS.RH.FEUILLES_DE_TEMPS.EDIT),
  staticData: {
    title: "Modifier le planning",
    icon: Edit,
    permission: PERMISSIONS.RH.FEUILLES_DE_TEMPS.EDIT,
  },
  component: ({ params }) => (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Modifier le planning</h1>
      <p className="text-base-content/60">
        ID: {params.id} - Le formulaire d'édition sera implémenté ici.
      </p>
    </div>
  ),
});
